import { render, staticRenderFns } from "./epb-toggle.component.vue?vue&type=template&id=34ffa92f&scoped=true"
import script from "./epb-toggle.component.vue?vue&type=script&lang=ts"
export * from "./epb-toggle.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-toggle.component.vue?vue&type=style&index=0&id=34ffa92f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffa92f",
  null
  
)

export default component.exports